<template>
  <detail-page-layout :config="pageConfig" class="leaseSentDetail">
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="[DataDetail]">
      <el-table-column label="发货通知单" prop="Code"></el-table-column>
      <el-table-column label="客户" prop="Partner.Name">
      </el-table-column>
      <el-table-column label="客户订单号" prop="Partner.Code">
      </el-table-column>
    </el-table>
    <h3 style="line-height: 3em;">物料清单</h3>

    <el-table :data="ProductLines" class="table-shin-expand" v-loading="IsLoading" element-loading-text="加载中">
        <el-table-column type="expand">
          <template scope="props">
            <div class="inner-list" v-for="Product in props.row" :key="Product.Id">
              <div class="list-item" style="min-width: 160px">
                <label>物料名称/编码</label>
                 <p class="no-margin">{{Product.Product.Name}}</p>
                 <p class="no-margin">物料编码：{{Product.Product.Code}}</p>
              </div>
              <div class="list-item" style="min-width: 160px">
                <label>客户物料名称/编码</label>
                <p class="no-margin">百叶窗防窥罩1 </p>
                <p class="no-margin">物料编码：004DZ2831GZ</p>
              </div>
              <div class="list-item" style="text-align: center;">
                <span class="el-tag el-tag--primary" style="margin-top: 8px">{{Product.Condition.Name}}</span>
              </div>
              <div class="list-item">
                <label>品牌：</label>
                <p class="no-margin">{{Product.Product.Brand.Name}}</p>
              </div>
              <div class="list-item">
                <label>机型：</label>
                <p class="no-margin">{{Product.Product.Model.Name}}</p>
              </div>
              <div class="list-item">
                <label>模块：</label>
                <p class="no-margin">{{Product.Product.Module.Name}}</p>
              </div>
              <div class="list-item">
                <label>数量：</label>
                <p class="no-margin">{{Product.Quantity}}</p>
              </div>
              <div class="list-item">
                <label>库存来源：</label>
                <p class="no-margin">{{Product.Type | inventorySource}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系人" min-width="100px">
          <template scope="props">{{props.row[0].ContactName}}</template>
        </el-table-column>
        <el-table-column label="联系电话" min-width="160px">
          <template scope="props">{{props.row[0].ContactPhone}}</template>
        </el-table-column>
        <el-table-column label="配送地址" min-width="200px">
          <template scope="props">{{props.row[0].Address}}</template>
        </el-table-column>
        <el-table-column label="物流类型" min-width="120px">
          <template scope="props">{{props.row[0].ShipmentMethod | ShipmentMethod}}</template>
        </el-table-column>
        <el-table-column label="配送类型" min-width="120px">
          <template scope="props">{{props.row[0].DeliveryType | ChangeDeliveryType}}</template>
        </el-table-column>
        <el-table-column label="预约时间" min-width="120px">
          <template scope="props">{{props.row[0].CreationTime | date('YYYY/MM/DD')}}</template>
        </el-table-column>
        <template v-if="Detail.State === 'finished'">
          <el-table-column label="物流公司" min-width="120px"></el-table-column>
          <el-table-column label="物流费用" min-width="120px"></el-table-column>
        </template>
      </el-table>
  </detail-page-layout>
</template>
<script>
import DetailPageLayout from '@/components/common/DetailPageLayout'
import o from '@/odata'
import _ from 'lodash'
export default {
  created() {
    this.getDataDetail()
  },
  data() {
    return {
      DataDetail: {},
      Detail: {},
      pageConfig: {
        StepsBarEnabled: true,
        Steps: [
          {key: 'receiving', title: '待确认'},
          {key: 'shipped', title: '待发货'},
          {key: 'finished', title: '已发货'},
        ],
        Step: 1,
        Breadcrumbs: [
          {
            to: {name: 'LeaseSentOrder'},
            name: '发货通知单',
          },
        ],
      },
      defaultSteps: [
        {key: 'receiving', title: '待确认'},
        {key: 'shipped', title: '待发货'},
        {key: 'finished', title: '已发货'},
      ],
      IsLoading: false,
    }
  },
  computed: {
    ProductLines() {
      let Lines = []
      if (this.DataDetail.Lines) {
        Lines = this.DataDetail.Lines.map(item => {
          // 处理收货地址
          const Province = item.Province && item.Province.Name || ''
          const City = item.City && item.City.Name || ''
          const County = item.County && item.County.Name || ''
          item.Address = Province + City + County + item.StreetAddress
          return item
        })
        Lines = Object.values(_.groupBy(Lines, 'AddressOrder'))
      }
      return Lines
    },
  },
  methods: {
     /* 获取订单详情 */
    getDataDetail() {
      this.IsLoading = true
      const id = this.$route.params.id
      o('ShipmentRequest').find(id).expand(`Partner($select=Id,Code,Name)`).expand('Lines($expand=Lots($expand=Lot),Province,City,County)')
        .get()
        .then(({ data }) => {
          this.IsLoading = false
          this.DataDetail = data
          this.updateSteps(data.State)
        }).catch((err) => {
          this.IsLoading = false
          let message
          switch (err.status) {
            case 404:
              message = '订单不存在'
              break
            default:
              message = `unkown error${err.status}`
          }
          this.$alert(message, 'Error!')
        })
    },
    updateSteps(State) {
      switch (State) {
        case 'draft':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 1)
          break
        case 'confirmed':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 2)
          break
        case 'finished':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 3)
          break
        case 'cancelled':
          this.$set(this.pageConfig, 'Steps', [this.defaultSteps[0], { key: 'fail', title: '已取消', state: 'failure' }])
          this.$set(this.pageConfig, 'Step', 2)
          break
      }
    },
  },
  components: {
    DetailPageLayout,
  },
}
</script>
<style lang="less">
.leaseSentDetail{
  .demo-table-expand {
      font-size: 0;
      padding-bottom:10px;
      margin-bottom:10px;
  }
  .table-data{
    border-bottom: 1px solid #ccc;
  }
  .demo-table-expand label {
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 8%;
  }
  .demo-table-expand .el-form-item.big-width {
    margin-right: 0;
    margin-bottom: 0;
    width: 18%;
  }
  .demo-table-expand .el-form-item.lot-width {
    margin-right: 0;
    margin-bottom: 0;
    width: 15%;
  }
  .demo-table-expand .el-form-item.modle-width {
    margin-right: 0;
    margin-bottom: 0;
    width: 8%;
  }
  .status{
    color: red;
  }
  .el-form-item__content{
    line-height: 16px;
  }
}
</style>
<style lang="less" scoped>
.detail-page {
  padding: 10px 30px;
}

.inner-list {
  margin: 0 30px;
  padding: 16px 28px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  border-bottom: 1px solid #e6eaee;
  &:last-child {
    border-bottom: none;
  }
  .list-item {
    margin-right: 20px;
    min-width: 50px;
    font-weight: bold;
    &:last-child {
      margin-right: 0;
    }
    label {
      font-size: 12px;
      color: #86939e;
      line-height: 1.5;
    }
    p {
      color: #364152;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// LeaseSentDetail_order.vue?e6713004